import { Family } from "protogen/advisors_service_pb";
import {
  createMenuOption,
  SubmenuMenuOption,
} from "components/common/PopperMenu";

const createCopyToOptions = (
  family: Family | undefined,
  families: Family[],
  onFamilySelect: (family: Family) => void,
  onSubmenuClick: () => void,
  includeClipboard: boolean = false,
  onCopyToClipboard: () => void = () => {},
) => {
  const options = [
    ...(includeClipboard
      ? [
          createMenuOption(
            "Copy to clipboard",
            () => {
              onCopyToClipboard();
            },
            "",
          ),
        ]
      : []),
    ...(family
      ? [
          createMenuOption(
            `${family?.name} task`,
            () => {
              onFamilySelect(family);
            },
            "",
          ),
        ]
      : []),
    <SubmenuMenuOption
      key="families"
      title="Families"
      onClick={(value) => {
        onSubmenuClick();
        const family = families.find((f) => f.ref === value);
        if (family) {
          onFamilySelect(family);
        }
      }}
      submenuOptions={families.map((f) => ({
        label: f.name,
        value: f.ref,
      }))}
    />,
  ];
  return options;
};

export { createCopyToOptions };
